<div class="dropdown">
  <div #toggleButton class="ng-content-area">
    <ng-content></ng-content>
  </div>

  <div #dropdownContent *ngIf="isDropdownOpen" [class.dropdown-opened]="isDropdownOpen && closeDropdownInternalClicked"
    class="dropdown-content">
    <!-- <i aria-hidden="true" class="dropdown-caret fas fa-caret-up fa-lg fa-fw"></i>
    <div (click)="closeDropDownInternal()" class="dropdown-top-menu">
      <i aria-hidden="true" class="fas fa-times fa-lg fa-fw"></i>
    </div> -->

    <div [style]="'min-width: ' + 330 * calculatedColumns + 'px;'" class="section-column-wrapper">
      <div *ngFor="let productLine of productLines; last as isLastColumn; index as i"
        [class.section-column-right-border]="!(i == calculatedColumns - 1 || isLastColumn)"
        [class]="productLine.color ? productLine.color : ''" [style]="getProductLineMaxHeight()" class="section-column">

        <div *ngIf="productLine.name" class="section-header">
          <h4>
            {{ productLine.name }}
          </h4>
          <p>
            {{ productLine.description.length < 80 ? productLine.description : productLine.description.substring( 0, 80
              ) + '..' }} </p>
              <hr />
        </div>

        <a (click)="closeDropDownInternal(product, productLine)"
          *ngFor="let product of productLine.products; last as isLast; first as isFirst"
          [class]="product.color ? product.color : ''" class="dropdown-item">
          <app-image-content-loader *ngIf="!product.imageLoaded" [imageContentLoaderClass]="'dropdown-item'"
            class="dropdown-item-logo"></app-image-content-loader>
          <img (load)="setImageLoaded(product)" [class.logo-under-maintenance]="product.url === URLS.maintenance"
            [src]="product.logo" [style]="'display:' + (!product.imageLoaded ? 'none;' : 'block;')" alt="logo"
            class="dropdown-item-logo" height="80" width="80" />

          <div class="dropdown-item-content">
            <h6>
              {{ product.name }}
            </h6>
            <p>
              Click here to know more! </p>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>